/**
 * Loads the slim reference catalogue from data/buildingInfo.json.
 *
 * The slim catalogue is an array of pre-normalised entries (id, name, width,
 * height, type) — it's the secondary source after the import's CityEntities
 * (see docs/architecture.md, "Catalogue resolver"). The full normalize()
 * pipeline still runs on these so the consumer always sees a ResolvedBuilding.
 */
import buildingInfo from '../../../data/buildingInfo.json'
import { normalize } from './normalize'
import type { ResolvedBuilding } from '$lib/types'

interface SlimEntry {
  id: string
  name: string
  width: number
  height: number
  type: string
}

const ENTRIES = buildingInfo as SlimEntry[]

let cache: Map<string, ResolvedBuilding> | null = null

function buildIndex(): Map<string, ResolvedBuilding> {
  const m = new Map<string, ResolvedBuilding>()
  for (const entry of ENTRIES) {
    m.set(entry.id, normalize(entry.id, entry))
  }
  return m
}

export function lookupReference(id: string): ResolvedBuilding | null {
  if (!cache) cache = buildIndex()
  return cache.get(id) ?? null
}

export function referenceSize(): number {
  if (!cache) cache = buildIndex()
  return cache.size
}
